import { render, staticRenderFns } from "./definition-community-management.vue?vue&type=template&id=22be207a&"
import script from "./definition-community-management.vue?vue&type=script&lang=js&"
export * from "./definition-community-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports